// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmAction_container__ybdly","title":"ConfirmAction_title__Je5Jx","description":"ConfirmAction_description__G0AS8","actions":"ConfirmAction_actions__ztPWt"};